import callWindowFunction from "../utils/callWindowFunction";

class CrossDomain {
  rootStore;

  /** Вкладка была ведомой и обладает актуальными данными */
  isWasLed = false;

  /** Вкладка ведущая */
  isMaster = false;

  /** Юзер на вкладке залогинен */
  isUserAuthorized = false;

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  becomeMasterAction = () => {
    this.isMaster = true;
    this.rootStore.websockets.notificationMasterAction();
    this.rootStore.chat.chatMasterAction();
  };

  finalMasterAction = () => {
    this.isMaster = false;
    this.rootStore.websockets.finalNotificationMasterAction();
    this.rootStore.chat.finalChatMasterAction();
  };

  becomeSlaveAction = () => {
    this.isMaster = false;

    // При перезагрузке страницы, когда до этого был всего один мастер
    // Начальное состояние вкладки - led.
    // Стоит подождать максимальное время обновления списка, чтобы подтвердить, что вкладка точно является ведомой
    setTimeout(() => {
      this.isWasLed = true;
    }, 4000);
    callWindowFunction("publishToEventBus", [
      {
        subject: "frontGetLastNotificationCounter",
        isForMaster: true,
        destination: "exceptThisTab",
        body: {},
      },
    ]);
    callWindowFunction("publishToEventBus", [
      {
        subject: "frontGetLastNotificationsCounters",
        isForMaster: true,
        destination: "exceptThisTab",
        body: {},
      },
    ]);
    callWindowFunction("publishToEventBus", [
      {
        subject: "frontGetChatUnreadCount",
        isForMaster: true,
        destination: "exceptThisTab",
        body: {},
      },
    ]);
  };

  getTechnicalInfo = () => ({
    app: "Header",
    data: [
      ...this.rootStore.websockets.getWSInfo(),
      ...this.rootStore.chat.getWSInfo(),
      ...this.rootStore.notifications.getSoundInfo(),
    ],
  });

  get isAuthorizedMaster() {
    return this.isMaster && this.isAuthorized;
  }

  /** Главная шина получения информации из других вкладок */
  eventBusMessageReceiver = (payload) => {
    const { websockets, chat, notifications, popupController, feeds } =
      this.rootStore;

    if (payload.subject === "frontWSNotificationMessage") {
      websockets.wsMessageHandler(payload.body);
    } else if (payload.subject === "frontWSChatMessage") {
      chat.createPopupNotification(payload.body);
    } else if (payload.subject === "frontWSChatMessageRead") {
      chat.handleReadAllChannelMessages(payload.body);
    } else if (payload.subject === "frontNotificationPollingMessage") {
      notifications.updateNotificationsTotal(payload.body);
    } else if (payload.subject === "frontNotificationsCounters") {
      notifications.updateNotificationsTotal(payload.body.total);
      feeds.updateImportantCounter(payload.body.important);

      feeds.initNotificationList(payload.body.important);
    } else if (payload.subject === "frontChatUnreadCount") {
      chat.setChatUnreadCount(payload.body);
    } else if (
      payload.subject === "frontGetLastNotificationCounter" &&
      this.isMaster
    ) {
      callWindowFunction("publishToEventBus", [
        {
          subject: "frontNotificationPollingMessage",
          destination: "exceptThisTab",
          body: notifications.notificationsNumber,
        },
      ]);
    } else if (
      payload.subject === "frontGetLastNotificationsCounters" &&
      this.isMaster
    ) {
      callWindowFunction("publishToEventBus", [
        {
          subject: "frontNotificationsCounters",
          destination: "exceptThisTab",
          body: {
            total: notifications.notificationsNumber,
            important: feeds.importantCount,
          },
        },
      ]);
    } else if (payload.subject === "frontGetChatUnreadCount" && this.isMaster) {
      callWindowFunction("publishToEventBus", [
        {
          subject: "frontChatUnreadCount",
          destination: "exceptThisTab",
          body: chat.chatUnreadCount,
        },
      ]);
    } else if (payload.subject === "frontNotificationPlaySound") {
      notifications.playSound(true);
    } else if (payload.subject === "frontUserTypeUpdate" && this.isMaster) {
      const { isWsStarted, getToken, finalNotificationMasterAction } =
        websockets;
      const { type } = payload.body;

      if (type === "user" && !isWsStarted) {
        this.isUserAuthorized = true;
        getToken();
      } else if (type === "unauthorized" && isWsStarted) {
        this.isUserAuthorized = false;
        finalNotificationMasterAction();
      }
    } else if (payload.subject === "popupControllerMessage") {
      popupController.popupControllerMessageReceiver(payload.body);
    } else if (payload.subject === "getTechInformation" && this.isMaster) {
      callWindowFunction("publishToEventBus", [
        {
          subject: "sendTechInformation",
          destination: "all",
          body: this.getTechnicalInfo(),
        },
      ]);
    } else if (payload.subject === "feedShowChatMessagesText") {
      feeds.setShowChatMessagesText(payload.body.value === "1", false);
    } else if (payload.subject === "feedCheckAllMessages") {
      feeds.clearNotificationList();
    }
  };
}

export default CrossDomain;
